// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductPartnershipLabel_container__pLPVM","viatorLogoWrapper":"ProductPartnershipLabel_viatorLogoWrapper___ZMlh"};